<template lang="html">
  <div
    id="navbarCeed"
    :class="[
      'navbar',
      isHome && 'home',
      isScroll && 'scroll',
      detectModal && 'display-none',
    ]"
  >
    <div class="container">
      <div class="icon-menu px-4 px-sm-0" @click="openCloseMenu">
        <svg
          width="22"
          height="18"
          viewBox="0 0 22 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="22" height="3.85714" rx="1.92857" fill="white" />
          <rect
            y="14.1429"
            width="22"
            height="3.85714"
            rx="1.92857"
            fill="white"
          />
          <rect y="7" width="22" height="4" rx="2" fill="white" />
        </svg>
      </div>
      <div class="logo">
        <router-link to="/">
          <img src="../../assets/LogoCEED.svg" alt="Logo" />
          <img src="../../assets/Logo-HEADER.svg" alt="Logo Blue" />
        </router-link>
      </div>
      <ul class="navbar-items">
        <li class="item active">
          <router-link to="/" class="link">Inicio</router-link>
        </li>
        <li class="item">
          <router-link to="/nosotros" class="link">Nosotros</router-link>
        </li>
        <li class="item">
          <router-link to="/recursos" class="link">Recursos</router-link>
        </li>
        <li class="item">
          <router-link to="/observatorio" class="link"
            >Observatorio</router-link
          >
        </li>
        <li class="item">
          <router-link to="/eventos" class="link">Eventos</router-link>
        </li>
        <li class="item">
          <router-link to="/contacto" class="link">Contacto</router-link>
        </li>
      </ul>
    </div>
  </div>
  <div :class="['navbar-menu', menuShow && 'show']">
    <div class="container">
      <div class="icon-close mx-4 mx-sm-0" @click="openCloseMenu">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.9998 5L5 18.9999"
            stroke="#013652"
            stroke-width="2.80001"
            stroke-linecap="round"
          />
          <path
            d="M5.00012 5L19 18.9999"
            stroke="#013652"
            stroke-width="2.80001"
            stroke-linecap="round"
          />
        </svg>
      </div>
      <div class="logo">
        <img
          src="https://i.ibb.co/P1jhvmb/Logo-Ceed-Blue.png"
          alt="Logo Blue"
        />
      </div>
      <ul class="navbar-items">
        <li class="item active">
          <router-link to="/" class="link">Inicio</router-link>
        </li>
        <li class="item">
          <router-link to="/nosotros" class="link">Nosotros</router-link>
        </li>
        <li class="item">
          <router-link to="/recursos" class="link">Recursos</router-link>
        </li>
        <li class="item">
          <router-link to="/observatorio" class="link"
            >Observatorio</router-link
          >
        </li>
        <li class="item">
          <router-link to="/contacto" class="link">Contacto</router-link>
        </li>
      </ul>
      <div class="social">
        <a href="#" class="item">
          <img
            src="https://i.ibb.co/7tY9QTQ/fb-social-blue.png"
            alt="facebook-social"
          />
        </a>
        <a href="#" class="item">
          <img
            src="https://i.ibb.co/cCQ9HBP/tw-social-blue.png"
            alt="twitter-social"
          />
        </a>
        <a href="#" class="item">
          <img
            src="https://i.ibb.co/xg37Hw7/lk-social-blue.png"
            alt="linkedin-social"
          />
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isHome: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isScroll: false,
      menuShow: false,
      detectModal: false,
    };
  },
  created() {
    window.addEventListener("scroll", this.isScrollNavActive);
    let htmlPage = document.querySelector("html");
    htmlPage.style.overflowY = "auto";
    window.scrollTo(0, 0);
  },
  unmounted() {
    window.removeEventListener("scroll", this.isScrollNavActive);
    this.detectModalNav();
  },
  mounted() {
    this.detectModalNav();
  },
  methods: {
    isScrollNavActive() {
      let nav = document.getElementById("navbarCeed");
      let windowPositionY = window.pageYOffset;
      if (windowPositionY > 100) {
        this.isScroll = true;
        if (this.isHome) nav.classList.remove("home");
      } else if (windowPositionY == 0) {
        if (this.isHome) nav.classList.add("home");
        this.isScroll = false;
      }
    },
    openCloseMenu() {
      let htmlPage = document.querySelector("html");
      if (this.menuShow) {
        let htmlPage = document.querySelector("html");
        htmlPage.style.overflowY = "auto";
      } else {
        htmlPage.style.overflowY = "hidden";
      }
      return (this.menuShow = !this.menuShow);
    },
    detectModalNav() {
      let estatus = localStorage.getItem("status");
      if (estatus == true) {
        this.detectModal = true;
      } else {
        this.detectModal = false;
      }
    },
  },
};
</script>
<style lang="css" scoped>
.navbar {
  padding: 40px 0 20px;
}
.navbar.home {
  padding: 60px 0 40px;
}
.navbar .container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: relative;
}
.navbar.home .container {
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.navbar .icon-menu,
.navbar.home .icon-menu {
  display: none;
}
.navbar .logo {
  width: 230px;
  margin-bottom: 0;
}
.navbar.home .logo {
  width: 280px;
  margin-bottom: 35px;
}
.navbar .logo img {
  width: 100%;
}
.navbar .logo img:nth-child(2) {
  display: none;
}
.navbar .navbar-items {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
}
.navbar .navbar-items .item {
  list-style: none;
  margin: 0 25px;
}

.navbar .navbar-items .item:first-child {
  margin-left: 0;
}
.navbar .navbar-items .item:last-child {
  margin-right: 0;
}
.navbar .navbar-items .item .link {
  text-decoration: none;
  display: block;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  color: #dadada;
}
.navbar.home .navbar-items .item .link {
  font-size: 18px;
  line-height: 21px;
}
.navbar .navbar-items .item .link.router-link-active {
  font-weight: 900;
  color: #ffffff;
}

.navbar,
.navbar.home {
  padding: 25px 0;
  margin-bottom: 36px;
  transition: all 0.3s ease-in-out;
}
.navbar.scroll,
.navbar.home.scroll {
  background: #ffffff;
  position: fixed;
  width: 100%;
  top: 0;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  z-index: 3 !important;
}

.navbar.scroll .navbar-items .item .link {
  color: #013652;
}
.navbar.scroll .navbar-items .item .link.router-link-active {
  color: #013652;
}
.navbar.scroll .logo img:nth-child(1) {
  display: none;
}
.navbar.scroll .logo img:nth-child(2) {
  display: block;
  width: 140px;
}
@media (max-width: 992px) {
  .navbar .container,
  .navbar.home .container {
    display: flex;
    flex-direction: row;
    position: relative;
    justify-content: center;
  }
  .navbar .icon-menu,
  .navbar.home .icon-menu {
    display: block;
    position: absolute;
    left: 0;
    cursor: pointer;
  }
  .navbar.scroll .icon-menu svg rect {
    fill: #33647e;
  }
  .navbar .logo,
  .navbar.home .logo {
    width: 100px;
    margin-bottom: 0;
  }
  .navbar .navbar-items {
    display: none;
  }
}
.navbar-menu {
  display: block;
  position: fixed;
  left: -100%;
  top: 0;
  width: 100%;
  height: 100vh;
  background: #ffffff;
  padding: 50px 0 100px;
  transition: left 0.3s ease-in-out;
  z-index: 2000;
}
.navbar-menu.show {
  left: 0;
}
.navbar-menu .container {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  position: relative;
}
.navbar-menu .icon-close {
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
  width: 30px;
}
.navbar-menu .logo {
  width: 140px;
}
.navbar-menu .logo img {
  width: 100%;
}
.navbar-menu .navbar-items {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  padding: 0;
  row-gap: 24px;
}
.navbar-menu .navbar-items .item {
  list-style: none;
}
.navbar-menu .navbar-items .item .link {
  text-decoration: none;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  text-align: center;
  color: #013652;
}
.navbar-menu .navbar-items .item .link.router-link-active {
  font-weight: 700;
}
.navbar-menu .social {
  display: flex;
  flex-direction: row;
  column-gap: 40px;
}
.navbar-menu .social .item {
  width: 40px;
}
.navbar-menu .social .item img {
  width: 100%;
}
.modal {
  z-index: auto !important;
}
.display-none {
  display: none !important;
}
</style>
